var UPC = {};
export {
  UPC as __exports
};
//# sourceMappingURL=index196.js.map
